import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { verifyDocument } from '@app/_models/verifyDocument';
import { VerifyDocumentService } from '@app/_services/verifyDocument.service';
import { LogService } from '@app/_shared/log.service';
import { first } from 'rxjs/operators';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssociateService } from '@app/_services/associate.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import * as _moment from 'moment';
import { Moment } from 'moment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'MMMM/YYYY',
  },
  display: {
    dateInput: 'MMMM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
@Component({
  selector: 'app-record-entry',
  templateUrl: './record-entry.component.html',
  styleUrls: ['./record-entry.component.css'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class RecordEntryComponent implements OnInit {
  date = new FormControl(moment());
  

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);

  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>, i) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    this.date.setValue(ctrlValue);
    datepicker.close();
    // var r = this.YearOfPassDropDown.find(x => x.yearOfPassing === this.date.value.year().toString());
    const myForm = (<FormArray>this.form.get("StudentDocVerificationRequest")).at(i);

    myForm.patchValue({
      yearAndMonth: this.date.value,
      yearAndMonthSelect: this.date.value,
      monthOfPassing: moment(this.date.value.month() + 1, 'MM').format('MMMM'),
      passingYear: this.date.value.year().toString(),
    });

  }
  dateFilter = (d: any): boolean => {
    const day = d.year();
    var val = [];
    this.YearOfPassDropDown.forEach((keys: any, vals: any) => {
      var x = keys.yearOfPassing;
      var y: number = +x;
      day !== y + "";
      val.push(y);
    })
    var alphaNumeric = val.join("  && day !== ");;
    var aq = (day !== + alphaNumeric);
    var stringValueYouWant = val.join();

    return stringValueYouWant.indexOf(d.year()) !== -1;
    //return aq;
  }
  fileSizeErr = false;
  verifyDocument = new verifyDocument();
  streams: string[];
  returnUrl;
  showErr = false;
  streamDropDown = [];
  collegeDropDown = [];
  YearOfPassDropDown = [];
  documentDropDown = [];
  rejectedData = [];
  IsmodelShowSecond;
  acceptedData = [];
  submitted = false;
  filePath;
  strMessage: string;
  finalArray = [];
  form: FormGroup;
  email = localStorage.getItem('userName');
  name = localStorage.getItem('firstname') + '' + localStorage.getItem('lastname');
  phoneNo = localStorage.getItem('phoneNo');
  amount;
  paymentId
  getStreamId: number;
  branchDropDown = [];
  semesterDropDown = [];
  RequestTypeDropDown = [];
  productForm: FormGroup;
  //btnAddMore:boolean= false;

  @ViewChild('closebuttonRemark') closebuttonRemark;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('confirmDatas', { read: TemplateRef }) confirmDataModalBox: TemplateRef<any>;
  @ViewChild('closebutton2') closebutton2;

  constructor(private modalService: NgbModal, config: NgbModalConfig, private fb: FormBuilder, private verifyDocService: VerifyDocumentService,
    private eventService: LogService, private router: Router, private associateService: AssociateService) { }

  callDispute(dataValue) {
    this.eventService.emit<string>(dataValue)
  }

  ngOnInit(): void {
    /* Initiate the form structure */
    this.IsmodelShowSecond = false;
    this.form = this.fb.group({
      StudentDocVerificationRequest: this.fb.array([
        this.initTimes()
      ])
    });
    this.fa.valueChanges.subscribe(value => {
      console.log('name has changed:', value)
    });
    this.verifyDocService.getStreams()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("streams response---", data.respData)
          this.streamDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getRequestType()
      .pipe(first())
      .subscribe(
        data => {
          this.RequestTypeDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getColleges()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.collegeDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

    // this.verifyDocService.getDocuments()
    //   .pipe(first())
    //   .subscribe(
    //     data => {
    //       // console.log("Document response---", data.respData)
    //       this.documentDropDown = data.respData;
    //     },
    //     error => {
    //       console.log(error)
    //     }
    //   )

    this.verifyDocService.getYearOfPassing()
      .pipe(first())
      .subscribe(
        data => {
          // console.log("YearOfPassing response---", data.respData)
          this.YearOfPassDropDown = data.respData;
        },
        error => {
          console.log(error)
        }
      )

  }

  initTimes() {
    return this.fb.group({
      stream: this.fb.control('', Validators.required),
      semester: this.fb.control('', Validators.required),
      // branch_nm: this.fb.control('', Validators.required),
      enrollmentNo: this.fb.control('', Validators.required),
      passingYear: this.fb.control('', Validators.required),
      // collegeName: this.fb.control('', Validators.required),
      uniid: "1",
      userid: localStorage.getItem('user_id'),
      // firstName: this.fb.control('', Validators.required),
      // lastName: this.fb.control('', Validators.required),
      originalDOCuploadfilePath: this.fb.control(''),
      filepath: this.fb.control('').status,
      yearAndMonth: this.fb.control(''),
      yearAndMonthSelect: this.fb.control(''),
      monthOfPassing: this.fb.control(''),
    });
  }

  get fa() { return this.form.get('StudentDocVerificationRequest') as FormArray; }

  generateUniqueId() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  addGroup() {
    this.fa.push(this.initTimes());
  }

  removeGroup(index) {
    this.fa.removeAt(index);
  }

  trackByFn(index: any, item: any) {
    return item.trackingId;
  }

  onSubmit() {
    this.IsmodelShowSecond = true;
    let firsReqTypeIdForVerification = this.RequestTypeDropDown.find(x => x.requestType === 'Verification').id;

    this.form.value.StudentDocVerificationRequest.forEach((item, i) => {
      this.form.value.StudentDocVerificationRequest[i].requesttype = firsReqTypeIdForVerification;
    });

    console.log('value: ', this.form.value.StudentDocVerificationRequest);
    console.log('valid: ', this.form.valid);
    this.submitted = true;
    if (this.form.valid == false) {
      console.log("here")
      this.showErr = true;

      return;
    }
    else {
      var v = this.form.value.StudentDocVerificationRequest[0].originalDOCuploadfilePath;
      var v1 = this.form.value.StudentDocVerificationRequest[0].filepath;
      if (v == "") {
        this.showErr = true;
        return;
      }
    };
    this.showErr = false;
    this.form.value.StudentDocVerificationRequest.forEach((item, i) => {
      this.form.value.StudentDocVerificationRequest[i].originalDOCuploadfilePath = this.form.value.StudentDocVerificationRequest[0].filepath;;
      this.form.value.StudentDocVerificationRequest[i].filepath = this.form.value.StudentDocVerificationRequest[0].filepath;
    });

    this.form.value.StudentDocVerificationRequest.forEach((item, i) => {
      this.form.value.StudentDocVerificationRequest[i].stream = this.streamDropDown.find(x => x.id === this.form.value.StudentDocVerificationRequest[i].stream).streamName;
    });

    this.finalArray.push(this.form.value);
    console.log(this.finalArray)
    this.IsmodelShowSecond = true;
    let associateId = localStorage.getItem('user_id');
    // if(this.file)
    if(this.fileSizeErr == false){

      this.associateService.confirmAssociateDocs(this.form.value.StudentDocVerificationRequest, associateId)
        .pipe(first())
        .subscribe(
          data => {
            this.modalService.open(this.confirmDataModalBox);
            // this.modalService.open(this.showModalBoxTemplate);
            console.log("reviewed data --->", data)
            this.rejectedData = data.respData.RejectedData;
            this.acceptedData = data.respData.savedStudentData;
            
            console.log("response---", data)
            // if (data.respMessage == "Success") {
            //   this.modalService.open(this.showModalBoxTemplate);
            // }
          },
          error => {
            console.log(error)
          }
        )
    }else{
      this.modalService.dismissAll(this.confirmDataModalBox);
    }
  }

  get docVerification() {
    return this.productForm.get('doc_verification') as FormArray;
  }

  refresh(): void {
    this.modalService.dismissAll(this.showModalBoxTemplate);
    this.eventService.emit<string>("30")
  }

  catchEvent(files: FileList, i) {
    console.log(files)
    console.log(i)
    if (files[0].size <= 1048576) {
      this.fileSizeErr = false;
      var formData = new FormData();
      formData.append("file", files.item(0));
      this.associateService.associateFileSave(formData)
        .pipe(first())
        .subscribe(
          data => {
            console.log("file---upload---response---", data)
            this.filePath = data.respData;
            this.updateData(i, data.respData);
          },
          error => {
            console.log(error)
          }
        )
    } else {
      this.fileSizeErr = true;
    }
  }

  updateData(index: number, data: String) {
    console.log(index, data)
    const myForm = (<FormArray>this.form.get("StudentDocVerificationRequest")).at(index);
    myForm.patchValue({
      filepath: data
    });
    console.log("Before=>", myForm);
    console.log("Before=>", myForm.value);
    console.log(myForm.value.firstname)
  }

  getBranAndStream(i: any, index) {

    let y = i.split(':')[1];
    let id = Number(y);
    this.verifyDocService.getBranch(id)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.branchDropDown[index] = data.respData;
        },
        error => {
          console.log(error)
        }
      )

    this.verifyDocService.getSemester(id)
      .pipe(first())
      .subscribe(
        data => {
          // console.log("college response---", data.respData)
          this.semesterDropDown[index] = data.respData;
        },
        error => {
          console.log(error)
        }
      )


  }
  closeAll() {
    location.reload();
  }
}
